import styled from 'styled-components'
import Flex from 'Components/Flex'

export const _TitleWithDeleteFlex = styled(Flex)`
  width: 100%;
  margin-bottom: 16px;

`

export const _Name = styled.div`
  font-size: 22px;
  line-height: 26px;
`

export const _BinIconContainer = styled.button.attrs({
  'data-test-id': 'alertCardDelete',
})`
  border: none;
  &:hover {
    cursor: pointer;
  }
`
